import { AltroSoggetto } from './altro-soggetto';
import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';
import { User } from './user';

export class Studio extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "studi";

  nome: string;
  users?: User[];
  firmatario: User;

  // Campi per gerarchia studi
  parent_studio_id?: number;
  is_root?: boolean;
  is_child_studio?: boolean;
  parent_studio?: Studio;
  child_studios?: Studio[];

  // Flag per detrazione emolumento accertatore
  detrazione_accertamento_su_incaricato: boolean = true;

  deserialize(input: any): Studio {
    let retV: Studio = new Studio();
    retV = super.deserialize(input) as Studio;

    if (input) {
      if (input?.users)
        this.users = input.users.map(u => new User().deserialize(u));
      if (input?.firmatario)
        this.firmatario = new User().deserialize(input.firmatario);

      // Deserializza campi gerarchia
      this.parent_studio_id = input.parent_studio_id;
      this.is_root = input.is_root;
      this.is_child_studio = input.is_child_studio;

      if (input?.parent_studio)
        this.parent_studio = new Studio().deserialize(input.parent_studio);

      if (input?.child_studios)
        this.child_studios = input.child_studios.map(s => new Studio().deserialize(s));

      // Deserializza flag detrazione (default true se non presente)
      this.detrazione_accertamento_su_incaricato = input.detrazione_accertamento_su_incaricato !== false;
    }

    return retV;
  }

  isRoot(): boolean {
    return this.is_root === true || !this.parent_studio_id;
  }

  isChildStudio(): boolean {
    return this.is_child_studio === true || !!this.parent_studio_id;
  }
}
